// extracted by mini-css-extract-plugin
export default {"cls1":"CdWD2DPyz0oHySyscEEk","cls2":"UDB5jGwEacB5DLiB4l9x CdWD2DPyz0oHySyscEEk"};